"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.provinces = void 0;
var provinces = exports.provinces = [{
  'name': '北京',
  'cities': [{
    'name': '北京',
    'hospitals': ['北大医疗康复医院管理有限公司', '北京精诚博爱医院有限公司', '北京年轮中医骨科医院', '北京华生康复医院有限公司', '北京和谐康复医院有限公司', '北京英智康复医院有限公司', '北京裕和中西医结合康复医院有限公司', '北京瑞安康复医院有限公司', '北京光熙康复医院有限公司', '北京绿康源医院', '北京丰台国康中西医结合医院', '北京健嘉康复医院有限公司', '北京丰台银龄中医院', '北京康仁康复医院管理有限公司', '北京军海中医医院有限公司', '北京崇文门中医院', '北京北亚骨科医院', '北京德尔康尼骨科医院', '北京清河医院', '北京丰台右安门医院', '北京王府井中西医结合医院', '北京新华卓越康复医院', '北京大兴兴和骨伤医院', '北京五路居中医医院', '北京常春中医医院', '北京骨卫士医疗科技有限公司', '京东中美医院', '北京安达医院', '北京惠兰医院', '北京九华医院']
  }]
}, {
  'name': '上海',
  'cities': [{
    'name': '上海',
    'hospitals': ['上海君爱康复医院有限公司', '上海申养康复医院有限公司', '上海永慈康复医院', '上海禾滨康复医院有限公司', '上海新起点康复医院有限公司', '上海慈源康复医院有限公司', '上海宏康医院有限公司', '上海清河湾康复医院有限公司', '上海览海康复医院有限公司', '上海健源康复医院', '上海祥瑞康复医院', '上海同康医院', '上海海华医院', '上海志高宝鼎医院', '上海安达医院', '上海同合骨科医院', '上海杨思医院', '上海颐山康复医院有限公司', '上海嘉华医院', '上海明州甬嘉康复医院有限公司', '上海仁爱医院有限公司', '上海誉华医院管理有限公司', '上海德颐护理院', '上海协爱中医医院', '上海九和堂中医医院有限公司', '上海礼孝护理院']
  }]
}, {
  'name': '广东',
  'cities': [{
    'name': '广州',
    'hospitals': ['广州脑博仕医院有限公司', '广州康德医院有限公司', '广州扶元堂康复服务有点公司', '广东祈福医院有限公司', '广州家家乐康复医院有限公司', '广州金太阳康复医院有限公司', '广东崇爱康复医院有限公司', '广州华兴康复医院有限公司', '广州蕙心医院', '广州番禺区健康管理中心', '赤冈中医医院', '广州广安医院', '广州东仁医院', '广州文明微创医院', '汕头大学广州华新骨科医院', '广东万民康复医院', '康源医院大源分院', '广东开强正康医院', '广州天河区击山医院', '广州百信医院']
  }, {
    'name': '深圳',
    'hospitals': ['深圳恒生医院', '深圳正康骨科医院', '深圳龙城医院', '深圳深业康复医院', '深圳健安医院', '深圳仁康医院', '深圳智康康复医院', '深圳禾正医院', '深圳复亚医院', '深圳中海医院', '深圳宝田医院', '深圳仁安医院', '深圳宝兴医院', '深圳五洲中医院', '深圳慈海医院', '深圳华侨医院', '深圳仁合医院', '深圳中旭医院', '深圳燕罗塘医院']
  }, {
    'name': '珠海',
    'hospitals': ['珠海白云康复医院有限公司', '珠海仁和骨伤医院有限公司']
  }, {
    'name': '汕头',
    'hospitals': ['汕头市长平康复医疗中心有限公司']
  }, {
    'name': '佛山',
    'hospitals': ['佛山复星禅诚医院有限公司']
  }, {
    'name': '韶关',
    'hospitals': ['六安华南康复医院有限公司']
  }, {
    'name': '河源',
    'hospitals': ['龙川华康医院有限公司']
  }, {
    'name': '梅州',
    'hospitals': ['梅州华南康复医院', '梅州客都骨科医院']
  }, {
    'name': '惠州',
    'hospitals': ['惠州惠康医院']
  }, {
    'name': '汕尾',
    'hospitals': ['汕尾中山医院']
  }, {
    'name': '东莞',
    'hospitals': ['东莞康华医院有限公司']
  }, {
    'name': '中山',
    'hospitals': ['中山爱达康康复医院有限公司']
  }, {
    'name': '江门',
    'hospitals': ['江门新会康怡康复医院有限公司']
  }, {
    'name': '阳江',
    'hospitals': ['阳江金太阳康复医院有限公司']
  }, {
    'name': '湛江',
    'hospitals': ['广东崇爱康复医院有限公司']
  }, {
    'name': '茂名',
    'hospitals': ['茂名石化医院有限公司']
  }, {
    'name': '肇庆',
    'hospitals': ['肇庆正大国健康复医院有限公司']
  }, {
    'name': '清远',
    'hospitals': ['清远清城健强医院有限公司']
  }, {
    'name': '潮州',
    'hospitals': ['潮州恒沃康复医院有限公司']
  }, {
    'name': '揭阳',
    'hospitals': ['揭阳市仕源医院有限公司']
  }, {
    'name': '云浮',
    'hospitals': ['云浮市惠民医院有限公司']
  }]
}, {
  'name': '天津',
  'cities': [{
    'name': '天津',
    'hospitals': ['天津康汇医院有限公司', '天津健嘉康复医院有限公司', '天津西青鼎翼骨科医院', '天津南开康泰医院', '天津华北医院', '天津津南区大德中医医院', '天津北辰津协医院', '天津航医心血管病医院']
  }]
}, {
  'name': '重庆',
  'cities': [{
    'name': '重庆',
    'hospitals': ['重庆朕尔职业病康复医院', '重庆广达康复医院有限公司', '重庆市中医骨科医院', '重庆长寿化工园区医院', '重庆好德医院', '重庆芳华医院有限责任公司', '重庆久聚康中西医结合医院有限公司', '重庆西区医院', '重庆渝东医院', '重庆綦江爱康康复医院', '重庆中健康复医院', '重庆善行康复医院', '西部康复医院重庆有限公司', '重庆汇康中西医结合医院']
  }]
}, {
  'name': '浙江',
  'cities': [{
    'name': '杭州',
    'hospitals': ['杭州康祥医院', '杭州九和医院', '杭州中兴医院', '桐庐康君护理院有限公司', '杭州广和医院', '杭州养和医院', '萧山康达中医院', '杭州佳业康复医院', '杭州康柏医院', '萧山康嘉医院', '杭州郡康怡德医院', '杭州乐天派英智康复医院', '杭州义德中医医院', '杭州禾正医院', '杭州东方华康康复医院', '萧山傅氏骨伤科医院', '杭州明州姑娘桥康复医院', '杭州明州康复医院', '建德中医院', '杭州临安德康中医医院', '杭州文仲中医医院', '杭州萧山石岩医院', '通用中铁富阳医院', '浙江康静医院有限公司']
  }, {
    'name': '嘉兴',
    'hospitals': ['嘉善广慈医院']
  }, {
    'name': '湖州',
    'hospitals': ['长兴第二医院', '长兴博济医院', '长兴和康护理院有限公司']
  }, {
    'name': '宁波',
    'hospitals': ['宁波明州医院', '宁波三环医院', '宁波老年康复医院']
  }, {
    'name': '温州',
    'hospitals': ['上海中医药大学温州协爱医院', '温州建国医院', '温州华侨伤骨科医院']
  }, {
    'name': '绍兴',
    'hospitals': ['绍兴明州康复医院', '绍兴舜济骨科医院', '绍兴柯北医院', '仁泽诸暨医院']
  }, {
    'name': '台州',
    'hospitals': ['台州黄岩新安康复医院']
  }, {
    'name': '金华',
    'hospitals': ['金华众康康复医院', '永康瑞侦医院', '金华顾连金帆康复医院']
  }, {
    'name': '舟山',
    'hospitals': ['舟山市普陀东大康复医院']
  }, {
    'name': '衢州',
    'hospitals': ['衢州康复医院']
  }, {
    'name': '丽水',
    'hospitals': ['丽水田氏骨科医院']
  }]
}, {
  'name': '四川',
  'cities': [{
    'name': '成都',
    'hospitals': ['成都市青白江区鑫朋康复医院', '成都嘉事康复医院有限公司', '成都顾连锦宸康复医院有限公司', '成都双流复馨康复医院有限公司', '四川现代医院', '成都城东康复医院有限公司', '四川赫尔森康复医院', '成都市德康医院', '成都金花医院']
  }, {
    'name': '绵阳',
    'hospitals': ['绵阳仁爱康复医院有限公司']
  }, {
    'name': '德阳',
    'hospitals': ['德阳东大医院', '德阳第五医院']
  }, {
    'name': '南充',
    'hospitals': ['南充友爱康复医院', '南充名仕医院']
  }, {
    'name': '自贡',
    'hospitals': ['自贡云山骨科医院', '自贡红新医院']
  }, {
    'name': '攀枝花',
    'hospitals': ['攀枝花盛泰康复医院', '攀枝花杏元医院']
  }, {
    'name': '泸州',
    'hospitals': ['泸州川蓝康复医院', '泸州骨康骨科医院']
  }, {
    'name': '广元',
    'hospitals': ['广元湘康慧民医院', '广元圣仁康医院']
  }, {
    'name': '遂宁',
    'hospitals': ['遂宁西华康复医院', '遂宁市安居利民康复医院']
  }, {
    'name': '内江',
    'hospitals': ['内江云川医院', '内江弘心医院']
  }, {
    'name': '乐山',
    'hospitals': ['乐山瑞和医院', '乐山和济堂中医康复医院']
  }, {
    'name': '资阳',
    'hospitals': ['资阳忠华康复医院', '资阳雁江扶民医院']
  }, {
    'name': '宜宾',
    'hospitals': ['宜宾国康医院', '宜宾和康医院']
  }, {
    'name': '达州',
    'hospitals': ['达州骨科医院', '达州华康医院']
  }, {
    'name': '雅安',
    'hospitals': ['雅安河北医院', '雅安仁康医院']
  }, {
    'name': '广安',
    'hospitals': ['广安致和康复医院', '广安华泰奎阁医院']
  }, {
    'name': '巴中',
    'hospitals': ['巴中市锡明骨科医院', '巴中仁爱中医康复医院']
  }, {
    'name': '眉山',
    'hospitals': ['眉山岷东医院有限公司']
  }]
}, {
  'name': '湖南',
  'cities': [{
    'name': '长沙',
    'hospitals': ['长沙桔洲康复医院有限公司', '湖南湘雅博爱康复医院有限公司', '长沙三益康复医院有限公司', '长沙三真康复医院', '长沙年轮骨科医院']
  }, {
    'name': '长沙市浏阳县',
    'hospitals': ['浏阳年轮骨科医院']
  }, {
    'name': '长沙市长沙县',
    'hospitals': ['星沙年轮骨科医院']
  }, {
    'name': '岳阳',
    'hospitals': ['岳阳仁雅康复医院']
  }, {
    'name': '衡阳',
    'hospitals': ['衡阳市新安康复医院']
  }, {
    'name': '株洲',
    'hospitals': ['株洲神农中医康复医院']
  }, {
    'name': '郴州',
    'hospitals': ['郴州橘井医院']
  }, {
    'name': '湘潭',
    'hospitals': ['湘潭福星仁科康复医院']
  }, {
    'name': '邵阳',
    'hospitals': ['邵阳正骨医院']
  }, {
    'name': '永州',
    'hospitals': ['永州市同康康复医院']
  }, {
    'name': '益阳',
    'hospitals': ['益阳高新康复医院']
  }, {
    'name': '娄底',
    'hospitals': ['娄底泓和医院']
  }, {
    'name': '怀化',
    'hospitals': ['怀化圣康医院']
  }, {
    'name': '张家界',
    'hospitals': ['张家界盛雅康复医院']
  }]
}, {
  'name': '湖北',
  'cities': [{
    'name': '武汉',
    'hospitals': ['武汉明州康复医院有限公司', '武汉知了康复有限公司']
  }, {
    'name': '襄阳',
    'hospitals': ['襄阳万顺骨科医院']
  }, {
    'name': '宜昌',
    'hospitals': ['宜昌夷陵弘仁康复医院']
  }, {
    'name': '荆州',
    'hospitals': ['荆州华侨医院']
  }, {
    'name': '孝感',
    'hospitals': ['孝感东南医院']
  }, {
    'name': '黄冈',
    'hospitals': ['黄冈平安康复医院']
  }, {
    'name': '十堰',
    'hospitals': ['十堰武当中西医结合医院']
  }, {
    'name': '荆门',
    'hospitals': ['荆门五三医院']
  }, {
    'name': '黄石',
    'hospitals': ['黄石爱康医院']
  }, {
    'name': '咸宁',
    'hospitals': ['咸宁爱康康复医院']
  }, {
    'name': '恩施',
    'hospitals': ['恩施东方医院（立鼎医疗服务有限公司）']
  }, {
    'name': '随州',
    'hospitals': ['随州大和康复医院']
  }, {
    'name': '鄂州',
    'hospitals': ['鄂州鄂钢医院']
  }, {
    'name': '仙桃',
    'hospitals': ['仙桃市同泰医院']
  }, {
    'name': '潜江',
    'hospitals': ['潜江优抚医院']
  }, {
    'name': '天门',
    'hospitals': ['天门康城医院']
  }]
}, {
  'name': '江西',
  'cities': [{
    'name': '南昌',
    'hospitals': ['南昌瑞康康复医院有限公司', '南昌健源康复医院有限公司']
  }, {
    'name': '上饶',
    'hospitals': ['上饶道源康复医疗中心', '上饶和康医院', '江西清水湾怡养康复医院', '上饶市道源康复医疗中心']
  }, {
    'name': '景德镇',
    'hospitals': ['浮梁金氏正骨医院']
  }, {
    'name': '萍乡',
    'hospitals': ['萍乡市赣西医院']
  }, {
    'name': '九江',
    'hospitals': ['江西赣北医院']
  }, {
    'name': '新余',
    'hospitals': ['新余福海精一康复医院']
  }, {
    'name': '鹰潭',
    'hospitals': ['鹰潭荣济骨科医院']
  }, {
    'name': '赣州',
    'hospitals': ['赣州泽康医院']
  }, {
    'name': '吉安',
    'hospitals': ['吉安仁安医院']
  }, {
    'name': '宜春',
    'hospitals': ['宜春汉方医院']
  }, {
    'name': '抚州',
    'hospitals': ['抚州九如城康复医院']
  }]
}, {
  'name': '江苏',
  'cities': [{
    'name': '苏州',
    'hospitals': ['苏州同德康复医院有限公司', '苏州苏城医院有限公司', '苏州明基医院', '苏州瑞盛康复医院有限公司']
  }, {
    'name': '南京',
    'hospitals': ['南京邦德中医医院有限公司', '江苏钟山老年康复医院', '南京一德康复医院有限公司', '南京明基医院', '南京瑞霞明州康复医院', '南京紫金医院', '南京扬子医院', '南京瑞海博康复医院']
  }, {
    'name': '无锡',
    'hospitals': ['江苏华卫医院有限公司', '无锡市康复医院', '无锡市国济康复医院有限公司']
  }]
}, {
  'name': '山东',
  'cities': [{
    'name': '济南',
    'hospitals': ['济南复元康复医院有限公司', '济南中德骨科医院']
  }, {
    'name': '威海',
    'hospitals': ['威海莱迪康复医院', '山东省文登整骨医院']
  }, {
    'name': '济宁',
    'hospitals': ['济宁海贝尔骨科医院有限公司']
  }, {
    'name': '聊城',
    'hospitals': ['聊城永衡康复医院']
  }, {
    'name': '青岛',
    'hospitals': ['青岛同华康复医院有限公司', '青岛福山康复医院', '青岛中康中医康复医院', '青岛宏远养和老年病医院有限公司', '青岛路乐康复医院']
  }, {
    'name': '潍坊',
    'hospitals': ['明德利康（山东）康复医疗有限公司', '潍坊高新尊一骨科医院', '山东潍坊恒泰康复医院']
  }, {
    'name': '泰安',
    'hospitals': ['泰安颐博康复医院']
  }, {
    'name': '日照',
    'hospitals': ['日照和泰康复医院']
  }]
}, {
  'name': '河南',
  'cities': [{
    'name': '郑州',
    'hospitals': ['郑州奥美康复医院有限公司', '郑州明州康复医院有限公司', '郑州金庚中医院有限公司', '郑州知了康复医院有限公司', '郑州仁济医院']
  }, {
    'name': '许昌',
    'hospitals': ['许昌仁和骨伤医院']
  }, {
    'name': '济源',
    'hospitals': ['济源东湖康复医院']
  }]
}, {
  'name': '河北',
  'cities': [{
    'name': '石家庄',
    'hospitals': ['石家庄容康中医医院有限公司', '河北省优抚医院', '石家庄长城中西医结合医院', '石家庄平安医院', '同仁堂中冀（石家庄）康复医院']
  }, {
    'name': '沧州',
    'hospitals': ['河北省沧州中西医结合医院']
  }, {
    'name': '秦皇岛',
    'hospitals': ['健瑞仕（秦皇岛）健康服务有限公司']
  }, {
    'name': '唐山',
    'hospitals': ['唐山任好康复医院有限责任公司']
  }]
}, {
  'name': '山西',
  'cities': [{
    'name': '太原',
    'hospitals': ['太原市同善康复医院有限公司']
  }]
}, {
  'name': '陕西',
  'cities': [{
    'name': '西安',
    'hospitals': ['西安国际医学中心', '陕西关爱康复医院有限公司']
  }]
}, {
  'name': '黑龙江',
  'cities': [{
    'name': '哈尔滨',
    'hospitals': ['哈尔滨七彩康复医院', '哈尔滨珠江康复医院有限公司', '仁芯医院', '中德骨科医院有限公司']
  }, {
    'name': '绥化市',
    'hospitals': ['明水县康盈医院']
  }, {
    'name': '佳木斯',
    'hospitals': ['佳木斯大学宏大医院', '明珠康复医院']
  }, {
    'name': '齐齐哈尔',
    'hospitals': ['建华医院有限责任公司']
  }, {
    'name': '鸡西',
    'hospitals': ['鸡西鸡矿医院有限公司']
  }, {
    'name': '鹤岗',
    'hospitals': ['鹤岗鹤矿医院有限公司']
  }, {
    'name': '双鸭山',
    'hospitals': ['双鸭山双矿医院']
  }, {
    'name': '大庆',
    'hospitals': ['大庆中医骨伤病医院', '大庆康复医院', '大庆立光康复医院']
  }, {
    'name': '伊春',
    'hospitals': ['伊春市民健中医医院有限公司']
  }, {
    'name': '七台河',
    'hospitals': ['七台河七煤医院有限公司']
  }, {
    'name': '牡丹江',
    'hospitals': ['牡丹江仁和医院']
  }, {
    'name': '绥化',
    'hospitals': ['绥化惠民医院']
  }, {
    'name': '大兴安岭',
    'hospitals': ['大兴安岭中西医结合医院']
  }]
}, {
  'name': '辽宁',
  'cities': [{
    'name': '沈阳',
    'hospitals': ['沈阳维康医院有限公司', '沈阳市沈北新区康健医院']
  }, {
    'name': '大连',
    'hospitals': ['大连立光康复医院']
  }, {
    'name': '鞍山',
    'hospitals': ['鞍山市金普医院']
  }, {
    'name': '朝阳',
    'hospitals': ['明达医院有限公司']
  }, {
    'name': '铁岭',
    'hospitals': ['铁岭新康医院有限公司']
  }, {
    'name': '锦州',
    'hospitals': ['锦州安泰医院有限公司']
  }, {
    'name': '葫芦岛',
    'hospitals': ['格万姆辽宁中医康复医院有限公司']
  }, {
    'name': '丹东',
    'hospitals': ['丹东泓信医院有限公司']
  }, {
    'name': '营口',
    'hospitals': ['营口方大医院有限公司']
  }, {
    'name': '抚顺',
    'hospitals': ['抚顺慈铭医院有限责任公司']
  }, {
    'name': '阜新',
    'hospitals': ['阜新市养和医院有限公司']
  }, {
    'name': '本溪',
    'hospitals': ['本溪泰达中西医结合医院有限公司']
  }, {
    'name': '盘锦',
    'hospitals': ['盘锦骨科医院有限公司']
  }, {
    'name': '辽阳',
    'hospitals': ['辽阳市济仁医院有限公司']
  }]
}, {
  'name': '吉林',
  'cities': [{
    'name': '长春',
    'hospitals': ['长春博远康复医院有限公司']
  }, {
    'name': '吉林',
    'hospitals': ['吉林月谭康复医院', '吉林国金医院', '吉林仲德骨科医院有限公司']
  }, {
    'name': '松原',
    'hospitals': ['松原仁大医院有限公司']
  }, {
    'name': '白城',
    'hospitals': ['白城华康医院']
  }, {
    'name': '白山',
    'hospitals': ['白山泰康医疗养护服务有限公司']
  }, {
    'name': '辽源',
    'hospitals': ['辽源辽河医院']
  }, {
    'name': '通化',
    'hospitals': ['通化建国中医医院']
  }, {
    'name': '四平',
    'hospitals': ['四平肿瘤医院']
  }]
}, {
  'name': '青海',
  'cities': [{
    'name': '西宁',
    'hospitals': ['青海省康乐医院有限公司']
  }]
}, {
  'name': '云南',
  'cities': [{
    'name': '昆明',
    'hospitals': ['昆明南大脑科医院有限公司', '云南中德骨科医院有限公司']
  }]
}, {
  'name': '贵州',
  'cities': [{
    'name': '贵阳',
    'hospitals': ['贵州福万康康复医院']
  }]
}, {
  'name': '广西',
  'cities': [{
    'name': '南宁',
    'hospitals': ['南宁市悦年华康复医院有限公司']
  }]
}, {
  'name': '福建',
  'cities': [{
    'name': '福州',
    'hospitals': ['福州华煦济康医院有限公司']
  }, {
    'name': '厦门',
    'hospitals': ['厦门弘爱康复医院有限公司']
  }, {
    'name': '莆田',
    'hospitals': ['莆田瑞斯康复医院有限公司']
  }, {
    'name': '三明',
    'hospitals': ['三明三元劲松康复医院']
  }, {
    'name': '泉州',
    'hospitals': ['泉州明州康复医院有限公司']
  }]
}, {
  'name': '内蒙',
  'cities': [{
    'name': '包头',
    'hospitals': ['包头市艾普托康复医院']
  }]
}, {
  'name': '海南',
  'cities': [{
    'name': '海口',
    'hospitals': ['海南中德骨科医院']
  }]
}, {
  'name': '甘肃',
  'cities': [{
    'name': '兰州',
    'hospitals': ['甘肃达尔健康复医院']
  }]
}];